(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-price"] && !Shopify.designMode) return;
  try {
    (function () {
    function positionCardLabel(event) {
      if (!(event.target instanceof Element)) return;
      const icon = event.target.closest('.sw-card-pictograms > .sw-card-pictogram');
      if (!icon) return;
      const label = icon.querySelector('.sw-card-pictogram__label');
      if (!label) return;

      const rect = icon.getBoundingClientRect();
      const width = label.getBoundingClientRect().width;
      const viewport = document.documentElement.clientWidth;
      label.style.left = Math.max(
        12 - rect.left,
        Math.min(0, viewport - 12 - rect.left - width)
      ) + 'px';
    }

    document.addEventListener('pointerover', positionCardLabel);
    document.addEventListener('focusin', positionCardLabel);
  })();
  } catch(e) { console.error(e); }
})();

})();
